import { Box, Grid } from '@mui/material';
import ButtonActions from '../../../../../../components/ButtonActions';
import { DrawerHeader } from '../../../../../../components/Drawer/DrawerHeader';
import CustomField from '../../../../../../components/CustomFormsComponents/CustomField';
import { useAppSelector } from '../../../../../../hooks/reduxHooks';
import useProviderForm, { ProviderFormData } from '../../hooks/useProviderForm';
import BackdropComponent from '../../../../../../components/Backdrop/BackdropComponent';

const NewProviderDrawer = ({ translate, selectedSubstance, handleCloseDrawer, isEditing, onlyVisual }: any) => {

    const selectedCarcinogenicReportId = useAppSelector(
        (state) => state?.carcinogenicReport?.selectedCarcinogenicReportId
    );

    const {
        formData: providerFormData,
        errors: providerErrors,
        providerFieldsConfig,
        isCreatingProvider,
        isEditingProvider,
        handleChange: providerHandleChange,
        handleSubmit
    } = useProviderForm({
        selectedSubstance,
        selectedCarcinogenicReportId,
        isEditing,
        handleCloseDrawer
    });
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            padding={1}
            sx={{ flexDirection: 'column', height: '100%' }}
        >
            <Grid>
                <DrawerHeader
                    onIconClick={handleCloseDrawer}
                    text={
                        !onlyVisual &&
                        translate(`newProviderForm.titles.${isEditing ? 'edit' : 'new'}`)
                    }
                />
                <Grid mt={2} container spacing={2} rowSpacing={0.01}>
                    {providerFieldsConfig.map((field, index) => (
                        <Grid
                            item
                            xs={field?.gridSpace?.xs}
                            sm={field?.gridSpace?.sm}
                            md={field?.gridSpace?.md}
                            lg={field?.gridSpace?.lg}
                            key={index}
                        >
                            <CustomField
                                config={field}
                                value={providerFormData[field.name as keyof ProviderFormData]}
                                onChange={providerHandleChange}
                                error={providerErrors[field.name as string]?.hasError}
                                helperText={
                                    providerErrors[field.name as string]?.errorMessage ||
                                    field.helperText
                                }
                                onlyVisual={onlyVisual}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ marginTop: '1rem' }}
            >
                {!onlyVisual && (
                    <Box
                        sx={{
                            '& > :not(style)': { m: 1 },
                            display: 'flex'
                        }}
                    >
                        <ButtonActions
                            handleClose={handleCloseDrawer}
                            renderBackAction
                            returnText={translate('newProviderForm.buttons.cancel')}
                            confirmText={translate('newProviderForm.buttons.save')}
                            loading={false}
                            disabled={false}
                            onClick={handleSubmit}
                            borderRadius="4px"
                            size="small"
                        />
                    </Box>
                )}
            </Grid>
            <BackdropComponent loading={isCreatingProvider || isEditingProvider} />
        </Box>
    );
};

export default NewProviderDrawer;
